export default "__VITE_ASSET__BsbZ$dnV__"